import React from 'react'
import './index.css'

const MarkerContainer = ({ children, title }) => (
  <div title={title} className="MarkerContainer">
    {children}
  </div>
)

export default MarkerContainer
